import {Component, EventEmitter, Inject, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilService} from "../../../services/util.service";
import {ActiveQuotesService} from "../../../services/active-quotes.service";
import {Router} from "@angular/router";
import {OktaAuthService} from "@okta/okta-angular";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatStepper} from "@angular/material/stepper";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import * as FileSaver from "file-saver";


@Component({
  selector: 'app-download-contract-dialog',
  templateUrl: './download-contract-dialog.component.html',
  styleUrls: ['./download-contract-dialog.component.scss']
})
export class DownloadContractDialogComponent implements OnInit {

  quoteForm: FormGroup;
  quoteFormData: any[];
  onClose = new EventEmitter();
  @ViewChild('stepper') stepper: MatStepper;
  stepperIndex: number = 0;
  userInfo: any;
  downloadInProgress: boolean = false;
  market: string;

  constructor(private dialogRef: MatDialogRef<DownloadContractDialogComponent>, @Inject(MAT_DIALOG_DATA) private data, private router: Router, public httpService: HttpClient, public form: FormBuilder, private quoteService: ActiveQuotesService, private utilService: UtilService, private oktaAuth: OktaAuthService, private sanitizer: DomSanitizer) { }

  async ngOnInit(): Promise<void> {
    this.oktaAuth.getUser().then(data => {
      this.userInfo = data;
    })
    await this.httpService.get('./assets/downloadContractMetadata.json').toPromise().then((res: any) => {
      this.data = this.mergeTermData(this.data);
      this.market = this.data.quoteDetails.market;
      this.quoteForm = this.form.group(this.createFormModel(res, this.data));
      this.quoteFormData = res;
      if(this.data.facilities){
        this.makeFacilities(this.data.facilities);
      }
      console.log(this.quoteForm.value);
    })
    // if(this.stepper) {
    //   this.stepper.selectionChange.subscribe(() => {
    //     this.stepperIndex = this.stepper.selectedIndex;
    //   })
    // }
  }

  nextStepper(){
    this.stepperIndex = this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
  }

  prevStepper(){
    this.stepperIndex = this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
  }

  get requestFacilities(){
    return this.quoteForm.get("facilities") as FormArray;
  }

  mergeTermData(termList){
    let data = JSON.parse((JSON.stringify(termList)));
    let termData = data.pricing[0];
    termData.fixedPrice = termData.fixedPrice.toFixed(2);
    data.pricing.forEach((item, ind) => {
      if(ind > 0){
        termData.fixedPrice = termData.fixedPrice + ';' + item.fixedPrice.toFixed(2);
        termData.term = termData.term + ';' + item.term;
      }
    })
    data.pricing = termData;
    return data;
  }

  makeFacilities(facilities){
    facilities.forEach(item => {
      this.requestFacilities.push(
        this.form.group(
          this.createFormModel(this.getMetaItem('facilities').items, item)
        )
      );
    })
  }

  getMetaItem(field){
    let filterItem = this.quoteFormData.filter(item => item.field == field);
    return filterItem[0];
  }

  createFormModel(metadata: any[], data?: object){
    let form = {};
    metadata.forEach(item => {
      if(item.type == 'array'){
        form[item.field] = this.form.array(item.field != 'facilities' ? [this.form.group(this.createFormModel(item.items, data && data[item.field]))]: [])
      }else if(item.type == 'object'){
        form[item.field] = this.form.group(this.createFormModel(item.items, data && data[item.field]));
      }else {
        // const {quotePricingProduct, market} = this.data.quoteDetails;
        // if(item.field != 'taxExempt' || (item.type == 'toggle' && market == 'ERCOT') || (item.type == 'percent' && market == 'PJM'))
        if(this.marketFieldBind(item))
          form[item.field] = [this.setDefaultValue(item, data), item.required ? [Validators.required]: []];
      }
    })
    return form;
  }

  marketFieldBind({field, type}){
    const {quotePricingProduct, market} = this.data.quoteDetails;
    let bindFlag = false;
    if(market == 'PJM'){
      if(type == 'percent' && field == 'taxExempt')
        bindFlag = true;
    }
    if(market == 'ERCOT') {
      if(type == 'toggle' && field == 'taxExempt' || field == 'startType' && quotePricingProduct && quotePricingProduct.indexOf('SCOM') >= 0 || field == 'transactionType')
        bindFlag = true;
    }
    if(!bindFlag && !['taxExempt', 'startType', 'transactionType'].includes(field)){
      bindFlag = true;
    }
    return bindFlag;

  }

  setDefaultValue({field, required, defaultValue, multiple}, data?: object){
    return  data ? data[field]: defaultValue || (multiple ? []: '');
  }

  getFormValue(field: any, item?: any, formInd?: number, parentItem?: any) {
    // jsonPath.value()
    let quoteForm: any;
    if(parentItem){
      quoteForm = this.quoteForm.get(parentItem.field) as FormGroup
    }else{
      quoteForm = this.quoteForm;
    }
    if(item && item.type == 'array' ){
      return quoteForm.get(item.field).value[formInd][field];
    }else if(item && item.type == 'object'){
      return quoteForm.get(item.field).value[field];
    }else{
      return this.quoteForm.get(field).value
    }
  }
  closeDialog(){
    this.onClose.emit();
  }

  async submitForm(){
    let quoteForm = this.quoteForm.value;
    let payload = {...quoteForm.pricing, ...quoteForm.customerInfo, ...quoteForm.address, ...{facilityList: quoteForm.facilities, broker: this.userInfo.brokerId}}
    if(typeof quoteForm.taxExempt != undefined){
      payload.taxExempt = quoteForm.taxExempt ? 'Y': 'N';
    }
    payload.listOfTerms = typeof payload.term == 'string' ? payload.term.split(';'): [payload.term];
    payload.listOfTerms = payload.listOfTerms.map(item => parseInt(item));
    payload.listOfFixedPrice = payload.fixedPrice.indexOf(';') >= 0 ? payload.fixedPrice.split(';'): [payload.fixedPrice];
    payload.listOfFixedPrice = payload.listOfFixedPrice.map(item => parseFloat(item));
    delete payload.term;
    delete payload.fixedPrice;
    this.downloadInProgress = true;
    this.dialogRef.disableClose = true;
    await this.quoteService.downloadContract(payload, this.data.quoteDetails.quoteNumber).toPromise().then((res: Blob) => {
      // let timeStamp = new Date().getTime();
      // FileSaver.saveAs(res, `contract_document_${timeStamp}`);
      if(res) {
        let fileName = this.generateFileName(payload.listOfTerms);
        FileSaver.saveAs(res, payload.listOfTerms.length > 1 ? fileName + '.zip' : fileName);
        this.utilService.successMessage('Downloaded Successfully');
        this.closeDialog();
        setTimeout(async () => {
          await this.router.navigate(['/contract-history']);
        });
      }else{
        this.utilService.errorMessage('Unfortunately there is a system issue please try again later');
      }
    }).catch((err: HttpErrorResponse) => {
      if(err.status == 500)
        this.utilService.errorMessage('Unfortunately there is a system issue please try again later');
      else
        this.utilService.errorMessage(err.message || 'failed to download');
    })
    this.dialogRef.disableClose = false;
    this.downloadInProgress = false;
  }

  generateFileName(term: number[]){
    let dateStamp = new Date().toJSON().slice(0, 10);
    let {customerName, product} = this.data.quoteDetails;
    product = product.replace(/\//g,'-');
    return `${term.length > 1 ? '': term[0] + 'M_'}${customerName}_${product}_${dateStamp}`;
  }
}
